import React from 'react';
import { Head } from '@inertiajs/react';
import ReactMarkdown from 'react-markdown';
import { Layout } from '../../components/Layout';

interface Document {
  id: number;
  title: string;
  content: string;
  policy_type: string;
  updated_at: string;
}

interface TermsProps {
  document: Document;
  user?: {
    id: number;
    name: string;
    email: string;
    username?: string;
    role?: 'user' | 'admin';
  };
}

const Terms: React.FC<TermsProps> = ({ document, user }) => {
  return (
    <Layout user={user}>
      <Head title={document.title} />
      <div className="min-h-[calc(100vh-4rem)] bg-background w-screen flex items-center justify-center p-8">
        <div className="max-w-4xl w-full space-y-8">
          <div className="prose prose-slate dark:prose-invert max-w-none bg-card p-8 rounded-lg shadow-sm">
            <ReactMarkdown>{document.content}</ReactMarkdown>
          </div>
          {document.updated_at && (
            <p className="text-sm text-muted-foreground text-center">
              Last updated: {new Date(document.updated_at).toLocaleDateString()}
            </p>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
